module.exports = __webpack_public_path__ + "img/icon-fund.ad089554.svg";